import { AuctionActivityResponse, AuctionResultResponse } from './auction-result.response';
import { AuctionActivityState, AuctionResultState } from './auction-result.state';

/** Pure wire → state mappers for the auction result and activity endpoints. */

export function mapAuctionResultResponse(response: AuctionResultResponse): AuctionResultState {
  return {
    ...response,
    settledAt: new Date(response.settledAt)
  };
}

export function mapAuctionActivityResponse(response: AuctionActivityResponse): AuctionActivityState {
  return {
    ...response,
    endsAt: new Date(response.endsAt)
  };
}
